const Modules = [
  {
    selectorName: "TypeaheadModule",
    selector: ".js-typeahead-overlay",
    importModule: () => import(/* webpackPrefetch: true */ "../modules/typeahead/TypeaheadModule"),
  },
  {
    selectorName: "HotspotBannerModule",
    selector: ".js-hotspot-banner-module",
    importModule: () => import(/* webpackPrefetch: true */ "../modules/hotspot-banner/HotspotBannerModule"),
  },
  {
    selectorName: "MobileUspModule",
    selector: ".js-mobile-usp-module",
    importModule: () => import(/* webpackPrefetch: true */ "../modules/mobile-usp/MobileUspModule"),
  },
  {
    selectorName: "TopmenuUspModule",
    selector: ".js-topmenu-usp-module",
    importModule: () => import(/* webpackPrefetch: true */ "../modules/topmenu-usp/TopmenuUspModule"),
  },
  {
    selectorName: "ProductStockOverlayModule",
    selector: ".js-pdp-stock-overlay",
    importModule: () => import(/* webpackPrefetch: true */ "../modules/pdp-stock-overlay/ProductStockOverlayModule"),
  },
  {
    selectorName: "ProductStockLabelModule",
    selector: ".js-pdp-stock-label",
    importModule: () => import(/* webpackPrefetch: true */ "../modules/pdp-stock-label/ProductStockLabelModule"),
  },
]

export default class DomFactory {
  constructor() {
    DomFactory.createModules()
    return this
  }
  static modules = {}
  static createModules() {
    for (let i = 0; i < Modules.length; i++) {
      let nodes = []
      let tags = document.querySelectorAll(Modules[i].selector)
      for (let x = 0; x < tags.length; x++) {
        Modules[i].importModule().then((module) => {
          new module.default(tags[x])
          nodes.push(module)
        })
      }
      if (nodes.length) DomFactory.modules[Modules[i].selectorName] = nodes
    }
  }
}

window.modules = DomFactory.modules
